/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzWS2 } from './pages'

type TIdToPageMapWoofzWS2 = Record<PageIdWoofzWS2, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZWS2: TIdToPageMapWoofzWS2 = {
  [PageIdWoofzWS2.AGE_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/DogAgeQuestionVersion2'
      ).then((m) => ({
        default: m.DogAgeQuestionVersion2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogAgeQuestionVersion2'),
  },
  [PageIdWoofzWS2.SEX_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/DogSexQuestionVersion2'
      ).then((m) => ({
        default: m.DogSexQuestionVersion2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogSexQuestionVersion2'),
  },
  [PageIdWoofzWS2.URGE_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ws2/pages/urge/UrgePage'),
  },
  [PageIdWoofzWS2.BREED_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogBreedQuestion').then(
        (m) => ({
          default: m.DogBreedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzWS2.URGE_WS2_2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzWS2.LICK_PAWS_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/LickPawsQuestion').then(
        (m) => ({
          default: m.LickPawsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/LickPawsQuestion'),
  },
  [PageIdWoofzWS2.DRAG_BOTTOM_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DragBottomQuestion').then(
        (m) => ({
          default: m.DragBottomQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DragBottomQuestion'),
  },
  [PageIdWoofzWS2.CHECK_EARS_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CheckEarsQuestion').then(
        (m) => ({
          default: m.CheckEarsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CheckEarsQuestion'),
  },
  [PageIdWoofzWS2.WASH_TEETH_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WashTeethQuestion').then(
        (m) => ({
          default: m.WashTeethQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WashTeethQuestion'),
  },
  [PageIdWoofzWS2.CLEAN_EYES_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CleanEyesQuestion').then(
        (m) => ({
          default: m.CleanEyesQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CleanEyesQuestion'),
  },
  [PageIdWoofzWS2.BREATH_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/BreathQuestion').then(
        (m) => ({
          default: m.BreathQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/BreathQuestion'),
  },
  [PageIdWoofzWS2.WEIGHT_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogWeightQuestion').then(
        (m) => ({
          default: m.DogWeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogWeightQuestion'),
  },
  [PageIdWoofzWS2.FEED_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/FeedQuestion').then(
        (m) => ({
          default: m.FeedQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/FeedQuestion'),
  },
  [PageIdWoofzWS2.FOOD_PORTIONS_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/FoodPortionQuestion'
      ).then((m) => ({
        default: m.FoodPortionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/FoodPortionQuestion'),
  },
  [PageIdWoofzWS2.URGE_WS2_4]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzWS2.WATER_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/DrinkingWaterQuestion'
      ).then((m) => ({
        default: m.DrinkingWaterQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DrinkingWaterQuestion'),
  },
  [PageIdWoofzWS2.CLEAN_BOWLS_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CleanBowlsQuestion').then(
        (m) => ({
          default: m.CleanBowlsQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CleanBowlsQuestion'),
  },
  [PageIdWoofzWS2.COAT_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/CoatLookingQuestion'
      ).then((m) => ({
        default: m.CoatLookingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/CoatLookingQuestion'),
  },
  [PageIdWoofzWS2.WALK_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WalkTimeQuestion').then(
        (m) => ({
          default: m.WalkTimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WalkTimeQuestion'),
  },
  [PageIdWoofzWS2.URGE_WS2_5]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzWS2.VET_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/VisitVetQuestion').then(
        (m) => ({
          default: m.VisitVetQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/VisitVetQuestion'),
  },
  [PageIdWoofzWS2.PROTECT_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/ParasiteProtectionQuestion'
      ).then((m) => ({
        default: m.ParasiteProtectionQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/ParasiteProtectionQuestion'
      ),
  },
  [PageIdWoofzWS2.CHRONIC_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/ChronicConditionsQuestion'
      ).then((m) => ({
        default: m.ChronicConditionsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/ChronicConditionsQuestion'
      ),
  },
  [PageIdWoofzWS2.BEHAVIOR_CHANGES_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/questions/BehaviorChangesQuestion'
      ).then((m) => ({
        default: m.BehaviorChangesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/BehaviorChangesQuestion'),
  },
  [PageIdWoofzWS2.URGE_WS2_6]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant6').then(
        (m) => ({
          default: m.UrgePageVariant6,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant6'),
  },
  [PageIdWoofzWS2.ITCH_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/ItchQuestion').then(
        (m) => ({
          default: m.ItchQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/ItchQuestion'),
  },
  [PageIdWoofzWS2.DOG_NAME_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogName').then((m) => ({
        default: m.DogName,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ws2/pages/questions/DogName'),
  },
  [PageIdWoofzWS2.SPEND_TIME_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/SpendTimeQuestion').then(
        (m) => ({
          default: m.SpendTimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/SpendTimeQuestion'),
  },
  [PageIdWoofzWS2.PREPARE_FLOW_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/prepareFlow/PrepareFlowWellness'
      ).then((m) => ({
        default: m.PrepareFlowWellness,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/prepareFlow/PrepareFlowWellness'),
  },
  [PageIdWoofzWS2.EMAIL_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/email/EmailWellness').then((m) => ({
        default: m.EmailWellness,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ws2/pages/email/EmailWellness'),
  },
  [PageIdWoofzWS2.NEWSLETTER_URGE_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_ws2/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzWS2.GIFT_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/urge/LastChanceOfferScratch/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ws2/pages/urge/LastChanceOfferScratch/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzWS2.SUBSCRIPTIONS_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/subscriptions/SubscriptionsWellness'
      ).then((m) => ({
        default: m.SubscriptionsWellness,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ws2/pages/subscriptions/SubscriptionsWellness'
      ),
  },
  [PageIdWoofzWS2.CANCEL_OFFER_WS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ws2/pages/subscriptions/CancelOfferWellness'
      ).then((m) => ({
        default: m.CancelOfferWellness,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/subscriptions/CancelOfferWellness'),
  },
  [PageIdWoofzWS2.CHAT_UPSELL_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzWS2.UPSELL_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_ws2/pages/upsell/Upsell'),
  },
  [PageIdWoofzWS2.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdWoofzWS2.DOWNLOAD_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/download-app/DownloadApp'),
  },
  // temporary unused pages
  [PageIdWoofzWS2.WORRIES_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WorriesQuestion').then(
        (m) => ({
          default: m.WorriesQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/WorriesQuestion'),
  },
  [PageIdWoofzWS2.URGE_WS2_3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant3'),
  },
  [PageIdWoofzWS2.ALONE_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogLeftAlone').then(
        (m) => ({
          default: m.DogLeftAlone,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogLeftAlone'),
  },
  [PageIdWoofzWS2.URGE_WS2_7]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant7').then(
        (m) => ({
          default: m.UrgePageVariant7,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant7'),
  },
  [PageIdWoofzWS2.SLEEP_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogSleepQuestion').then(
        (m) => ({
          default: m.DogSleepQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/DogSleepQuestion'),
  },
  [PageIdWoofzWS2.SLEEPING_ENV_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/questions/SleepingEnviroment').then(
        (m) => ({
          default: m.SleepingEnviroment,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/questions/SleepingEnviroment'),
  },
  [PageIdWoofzWS2.URGE_WS2_8]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant8').then(
        (m) => ({
          default: m.UrgePageVariant8,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant8'),
  },
  [PageIdWoofzWS2.URGE_WS2_9]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant9').then(
        (m) => ({
          default: m.UrgePageVariant9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgePageVariant9'),
  },
  [PageIdWoofzWS2.WELCOME_WS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgeDiscountPage').then(
        (m) => ({
          default: m.UrgeWellnessDiscount,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ws2/pages/urge/UrgeDiscountPage'),
  },
}
